export default "__VITE_ASSET__6026837b__"